/*
 * @FilePath: index.js
 * @Author: chenwei
 * @Date: 2022-02-09 10:18:02
 * @LastEditors: chenwei
 * @LastEditTime: 2022-07-11 18:49:24
 * Copyright: 2022 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion: 
 */
import {get,post} from '@/utils/request'
import {proxyHeader} from "@/utils/config"

//edit
export const getShopCarList = p => get(proxyHeader+'service/order-service/car/list', p);

export const deleteShopCarSite = p => post(proxyHeader+'service/order-service/car/delete', p);

//获取订单类型
export const getOrderTypeFromShopCar = (p) => get(proxyHeader+'service/common-service/sys-dic-item/listByDicCode', p);

//清空购物车
export const clearShopCarData = p => post(proxyHeader+'service/order-service/car/clearAll', p);

//批量加入购物车
export const addToShopCar = p => post(proxyHeader+'service/order-service/car/addCar', p);

//一键生成订单
export const addAllToOrder = p => post(proxyHeader+'service/order-service/order/applyOrderForTotalCar', p);
